import React, { Component } from 'react'
import { Col, Row, message, Modal } from 'hljd'
import { inject, observer } from 'mobx-react'
import API from '@api/bi_nuo/liveManage'
import { toJS } from 'mobx'
import Style from './style.module.less'

//中奖名单
import WinningUsersModal from './winningUsersModal.js'
//新增、编辑抽奖组件
import AddGiftModal from './addGiftModal.js'

const { confirm } = Modal

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.liveLotteryStore = props.store.liveLotteryStore
    this.saveLiveLottery = this.saveLiveLottery.bind(this)
  }
  UNSAFE_componentWillMount() {
    this.liveLotteryStore.getGiftLists()
    const fn = () => {
      this.liveLotteryStore.getGiftLists()
      this.getGiftListsTimer = setTimeout(fn, 2000)
    }
    this.getGiftListsTimer = setTimeout(fn, 2000)
  }
  componentWillUnmount() {
    clearInterval(this.getGiftListsTimer)
  }

  //保存奖项
  saveLiveLottery(e) {
    e.preventDefault()
    e.stopPropagation()
    const {
      liveLotteryModalInfo,
      channel_id,
      emptyLiveLottery,
      getGiftLists,
      liveLotteryModalInfo: { modalStatus }
    } = this.liveLotteryStore
    const params = Object.assign({}, toJS(liveLotteryModalInfo), {
      channelId: channel_id
    })
    const {
      form: { validateFieldsAndScroll }
    } = this.addGiftForm.props
    validateFieldsAndScroll(async err => {
      if (!err) {
        console.log('params', params)
        if (modalStatus == 'view') {
          emptyLiveLottery() //清空弹框状态
          return false
        }
        confirm({
          title: `确认${modalStatus ? '编辑' : '添加'}抽奖吗？`,
          async onOk() {
            delete params.modalStatus
            const { success } = await API.editLiveGift(params)
            if (success) {
              message.success('操作成功！')
              emptyLiveLottery() //清空弹框状态
              getGiftLists() //重新获取抽奖list
            }
          }
        })
      }
    })
  }
  render() {
    const {
      giftLists,
      liveStatus,
      getLimitTime,
      getOperationDom,
      emptyLiveLottery,
      liveLotteryModalInfo,
      handleFormChange
    } = this.liveLotteryStore
    return (
      <div className={Style['live-lottery-wrap']}>
        <Row>
          <Col span={2} style={{ textAlign: 'right', width: 70 }}>
            玩法介绍
          </Col>
          <Col
            offset={1}
            span={21}
            style={{
              display: 'inline-block',
              height: '22px',
              lineHeight: '22px'
            }}
          >
            <a
              href="https://www.yuque.com/zhiboxiaozhushou/tihy4t/tipf7f"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#FF801A' }}
            >
              点击这里解锁抽奖工具玩法
            </a>
          </Col>
        </Row>
        <Row>
          <Col span={2} style={{ textAlign: 'right', width: 70 }}>
            抽奖设置
          </Col>
          <Col offset={1} span={21}>
            <div className={Style['gift-item-wrap']}>
              {giftLists &&
                giftLists.map(item => {
                  const { id, giftName, watchTime, status, winningNum } = item
                  return (
                    <div className={Style['gift-item']} key={id}>
                      {status == 2 ? (
                        <div className={Style['gift-item-stop']}>已终止</div>
                      ) : null}
                      <div className={Style['gift-item-head']}>
                        <p>抽奖 : {giftName}</p>
                        {watchTime ? (
                          <p>观看满{getLimitTime(watchTime)}抽奖</p>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className={Style['gift-item-foot']}>
                        {getOperationDom({
                          winningNum,
                          liveStatus,
                          id,
                          status
                        })}
                      </div>
                    </div>
                  )
                })}
            </div>
            <div
              className={`${Style['add-gift']} ${
                giftLists.length < 3 ? '' : Style['add-gift-disable']
              }`}
              onClick={() =>
                giftLists.length < 3 ? emptyLiveLottery() : false
              }
            >
              <img
                src="https://qnm.hunliji.com/o_1dkg6843q9e91o3oq4g1a61nhut.png"
                alt="添加抽奖"
                style={{ width: 32, height: 32, marginBottom: '10px' }}
              />
              <span>添加抽奖</span>
            </div>
            <div style={{ color: '#448afc', marginTop: '10px' }}>
              注：最多只能添加3个抽奖活动
            </div>
          </Col>
        </Row>
        <WinningUsersModal />
        <AddGiftModal
          wrappedComponentRef={form => (this.addGiftForm = form)}
          fields={liveLotteryModalInfo}
          onChange={handleFormChange}
          handleConfirm={this.saveLiveLottery}
        />
      </div>
    )
  }
}
